<template>
  <div
    v-if="!loading"
    class="user-main-content vs_mainContentWrapper"
  >
    <page-head
      small
      :title="pageHead"
      show-back
    >
    </page-head>

    <page-content>
      <v-row class="my-3 px-3 justify-content-flex-end">
        <v-col
          class="d-flex header-card"
          cols="10"
        >
          <div class="info-item-details-value text-h6 mt-3 col col-6">
            <span class="title"> {{ local.caseFile.session.remoteArgument.sessionStatus }}: </span>
            <div>
              {{ remoteArgumentStatus }}
            </div>
          </div>

          <div
            v-if="isRemoteArgumentOrCaseManagementELitigation"
            class="info-item-details-value text-h6 mt-3 col col-5"
          >
            <span class="title"> {{ local.caseFile.session.remoteArgument.endDate }}: </span>
            <div>
              {{ formatDateString(caseDetails.finishedDate) }}
            </div>
          </div>

          <div
            v-if="sessionTypeId == sessionTypes.expert && sessionDto && sessionDto.appointmentEndTime"
            class="info-item-details-value text-h6 mt-3 col col-5"
          >
            <span class="title"> {{ local.caseFile.session.remoteArgument.endDate }}: </span>
            <div>
              {{ formatDateString(sessionDto.appointmentEndTime) }}
            </div>
          </div>

          <template v-if="isRemoteArgumentOrCaseManagementELitigation && !isNajizOrganization">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item>
                  <v-list-item-title>
                    <router-link
                      to="/"
                      class="new-request-button"
                    >
                      <naj-button
                        text
                        type="button"
                        size="small"
                      >
                        {{ local.caseFile.session.extendPleading }}
                      </naj-button>
                    </router-link>
                  </v-list-item-title>
                </v-list-item>

                <v-list-item v-if="headStatusActive && !publicReplyAllowed && !showMessageReplied">
                  <v-list-item-title>
                    <naj-button
                      text
                      type="button"
                      size="small"
                      @click="showRequestReplyDialog = true"
                    >
                      {{ local.caseFile.session.requestPublicReply }}
                    </naj-button>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-col>
      </v-row>

      <naj-box :title="local.caseFile.session.remoteArgument.responseAndRequests">
        <div class="contentTile__messagesWrapper">
          <div
            ref="chatBox"
            class="contentTile__messagesItems"
          >
            <template v-if="writtenPleadingMessages && writtenPleadingMessages.length > 0">
              <div
                v-for="message of writtenPleadingMessages"
                :key="message.objectKey"
              >
                <div
                  v-if="message.category !== 2"
                  :id="message.objectKey"
                  class="contentTile__messagesItem"
                  :class="[messageType(message), directionClass(message)]"
                >
                  <div class="contentTile__messagesHeder">
                    <div class="contentTile__messagesName">
                      {{ getSenderNameAndRole(message) }}
                    </div>
                    <div class="contentTile__messagesDate">
                      {{ formatDateString(message.messageDate) }}
                    </div>
                  </div>
                  <div class="contentTile__messagesBody">
                    {{ message.messageText }}
                  </div>
                  <div
                    v-if="message.sharepointId && message.sharepointId != ''"
                    class="contentTile__messagesAttachments"
                  >
                    <router-link
                      :to="`${apiModule.SYSTEM}/SharePoint/download-trusted-source/documents?documentId=${message.sharepointId}`"
                      class="btn btn-sm btn-outline-secondary"
                      target="_blank"
                    >
                      {{ message.attachmentTitle }} {{ local.caseFile.session.remoteArgument.downLoadFile }}
                    </router-link>
                  </div>
                  <div
                    v-if="message.category === 1"
                    class="contentTile__messageReplayTools"
                  >
                    <span class="replayLastDate">
                      <strong>{{ local.caseFile.session.remoteArgument.lastReplyDate }}:</strong>
                      {{ formatDateString(message.replyEndDate) }}
                    </span>
                    <span
                      v-if="message.allowAttachmentsInReplies"
                      class="replayAttachment"
                    >
                      <img src="../../../../public/img/replayAttachment.svg">
                      {{ local.caseFile.session.remoteArgument.attachmentAllowed }}
                    </span>
                    <span
                      v-if="!message.allowAttachmentsInReplies"
                      class="replayAttachment notAllowed"
                    >
                      <img src="../../../../public/img/replayAttachmentNA.svg">
                      {{ local.caseFile.session.remoteArgument.attachmentNotAllowed }}
                    </span>
                    <span
                      v-if="hasReply(message)"
                      class="replayAttachment"
                    >{{ local.caseFile.session.remoteArgument.hasReplied }}</span>
                    <span
                      v-if="replyDisabledFromJudge(message)"
                      class="replayAttachment"
                    >{{ local.caseFile.session.remoteArgument.replyDisabled }}</span>
                    <button
                      v-if="!isNajizOrganization"
                      class="replayToJudgeBtn"
                      :disabled="!checkFromPermission(message)"
                      @click="onShowMessageReplied(message.objectKey)"
                    >
                      {{ sessionTypeId == sessionTypes.expert ? local.caseFile.session.remoteArgument.expertReply : local.caseFile.session.remoteArgument.replyToJudgeMessage }}
                    </button>
                  </div>
                </div>
                <div v-if="message.category === 2 && validateParentMessages(message)">
                  <div
                    :key="message.objectKey"
                    class="contentTile__messagesItem"
                    :class="[directionClass(message), messageType(message)]"
                  >
                    <div class="contentTile__messagesHeder">
                      <div class="contentTile__messagesName">
                        {{ getSenderNameAndRole(message) }}
                      </div>
                      <div class="contentTile__messagesDate">
                        {{ formatDateString(message.messageDate) }}
                      </div>
                    </div>
                    <!-- Answers Section -->
                    <template v-for="(parentMessage, index) of writtenPleadingMessages">
                      <div
                        v-if="parentMessage.id === message.parentMessageId"
                        :key="index"
                        class="contentTile__messagesItem contentTile__messagesQuotes"
                        @click="scrollToElement(parentMessage)"
                      >
                        <div class="contentTile__messagesHeder">
                          <div class="contentTile__messagesName">
                            {{ getSenderNameAndRole(parentMessage) }}
                          </div>
                          <div class="contentTile__messagesDate">
                            {{ formatDateString(parentMessage.messageDate) }}
                          </div>
                        </div>
                        <div class="contentTile__messagesBody">
                          {{ parentMessage.messageText }}
                        </div>
                      </div>
                    </template>

                    <div class="contentTile__messagesBody">
                      {{ message.messageText }}
                    </div>
                    <div
                      v-if="message.sharepointId && message.sharepointId != ''"
                      class="contentTile__messagesAttachments"
                    >
                      <router-link
                        :to="`${apiModule.SYSTEM}/SharePoint/download-trusted-source/documents?documentId=${message.sharepointId}`"
                        class="btn btn-sm btn-outline-secondary"
                        target="_blank"
                      >
                        {{ message.attachmentTitle }} {{ local.caseFile.session.remoteArgument.downLoadFile }}
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>

          <div
            v-if="headStatusActive && !publicReplyAllowed"
            class="contentTile__newMessageControl"
          >
            <div
              v-if="showMessageReplied"
              class="contentTile__messagesItem departmentRequest MessageReplied"
            >
              <div class="contentTile__messagesHeder">
                <div class="contentTile__messagesName">
                  {{ getSenderNameAndRole(messageReplied) }}
                </div>
                <div class="contentTile__messagesDate">
                  {{ formatDateString(messageReplied.messageDate) }}
                  <i
                    class="fas fa-times"
                    @click="hideMessageReplied()"
                  />
                </div>
              </div>
              <div class="contentTile__messagesBody">
                {{ messageReplied.messageText }}
              </div>
            </div>
            <div
              v-if="showMessageReplied"
              class="form-group"
            >
              <v-form ref="remoteArgumentReplyRef">
                <naj-input
                  :type-id="formFieldType.textarea"
                  :label="local.caseFile.session.remoteArgument.reply"
                  :value.sync="newMessage"
                  rows="5"
                  validates="required|max:2000"
                ></naj-input>
              </v-form>
            </div>
            <div
              v-if="showMessageReplied"
              class="form-group contentTile__newMessageSend"
            >
              <v-col
                v-if="fileData && fileData.sharePointId"
                cols="6"
              >
                <attachment-card
                  :file="{ ...uploadedFile }"
                  :show-delete-button="!isViewMode"
                  @deleteAttachment="showDeleteFileDataModal"
                  @viewAttachment="viewAttachment"
                ></attachment-card>
              </v-col>
              <template v-else>
                <load-local-attachment
                  v-if="allowAttachment"
                  :max-file-size="5"
                  :upload-disabled="isViewMode"
                  @fileSelected="fileSelected"
                >
                </load-local-attachment>
              </template>
              <button
                type="button"
                class="btn btn-primary pleading-reply-button"
                :disabled="!disableSubmit"
                @click="confirmSend = true"
              >
                {{ local.caseFile.session.remoteArgument.addReply }}
              </button>
            </div>
          </div>

          <div
            v-if="headStatusActive && publicReplyAllowed && !showMessageReplied"
            class="contentTile__newMessageControl"
          >
            <v-form ref="remoteArgumentReplyRef">
              <div class="form-group">
                <naj-input
                  :type-id="formFieldType.textarea"
                  :label="local.caseFile.session.remoteArgument.reply"
                  :value.sync="newMessage"
                  rows="5"
                  validates="required|max:200"
                ></naj-input>
              </div>
            </v-form>
            <div class="form-group contentTile__newMessageSend">
              <v-col
                v-if="fileData && fileData.sharePointId"
                cols="6"
              >
                <attachment-card
                  :file="{ ...uploadedFile }"
                  :show-delete-button="!isViewMode"
                  @deleteAttachment="showDeleteFileDataModal"
                  @viewAttachment="viewAttachment"
                ></attachment-card>
              </v-col>
              <template v-else>
                <load-local-attachment
                  v-if="allowAttachment"
                  :max-file-size="5"
                  :upload-disabled="isViewMode"
                  @fileSelected="fileSelected"
                >
                </load-local-attachment>
              </template>
              <button
                type="button"
                class="btn btn-primary pleading-reply-button"
                :disabled="!disableSubmit"
                @click="confirmSend = true"
              >
                {{ local.caseFile.session.remoteArgument.addReply }}
              </button>
            </div>
          </div>

          <div
            v-if="isRemoteArgumentOrCaseManagementELitigation && headStatusActive && !publicReplyAllowed && !showMessageReplied && !isNajizOrganization"
            class="contentTile__newMessageControl"
          >
            <div class="form-group contentTile__newMessageSend">
              <button
                type="button"
                class="btn btn-primary pleading-reply-button"
                @click="showRequestReplyDialog = true"
              >
                {{ local.caseFile.session.requestPublicReply }}
              </button>
            </div>
          </div>
        </div>
      </naj-box>

      <template v-if="isRemoteArgumentOrCaseManagementELitigation">
        <naj-box :title="local.caseFile.session.remoteArgument.replyRequests">
          <div class="contentTile__messagesWrapper">
            <naj-data-table
              no-header
              :headers="publicReplyRequestsHeaders"
              :items="publicReplyRequestsMapped"
              :disable-items-per-page="true"
              no-margin-bottom
            >
            </naj-data-table>
          </div>
        </naj-box>

        <naj-box
          v-if="false"
          :title="local.caseFile.session.remoteArgument.replyNote"
        >
          <div class="contentTile__messagesWrapper mb-6">
            <h5 class="mb-4">
              {{ local.caseFile.session.remoteArgument.prosecutionNotes }}
            </h5>
            <naj-data-table
              no-header
              :headers="lawsuitReplyNoteRequestHeaders"
              :items="lawsuitReplyNoteRequestMapped.prosecutionNotes"
              :disable-items-per-page="true"
              no-margin-bottom
            >
            </naj-data-table>
            <!-- <reply-note
						  v-if="caseInfo"
						  ref="replyNote"
						  :service-name="RequestService"
						  :case-i-d="CaseId"
						  @cancel="cancelRequest"
						  @confirmSubmit="ConfirmSubmit"
						  @saveRequest="SaveRequest"
						></reply-note> -->
          </div>
          <div class="contentTile__messagesWrapper mb-6">
            <h5 class="mb-4">
              {{ local.caseFile.session.remoteArgument.defenseNotes }}
            </h5>
            <naj-data-table
              no-header
              :headers="lawsuitReplyNoteRequestHeaders"
              :items="lawsuitReplyNoteRequestMapped.defenseNotes"
              :disable-items-per-page="true"
              no-margin-bottom
            >
            </naj-data-table>
          </div>
        </naj-box>
      </template>
    </page-content>

    <naj-confirmation
      :show-modal="warningDialog"
      :max-width="1500"
      :is-persistent="false"
      :title="`${local.caseFile.session.remoteArgument.termsAndConditions}:`"
      :ok-btn-label="local.common.agree"
      :close-btn-label="local.common.back"
      @ok="confirmAttendance"
      @cancel="warningDialogCancel"
    >
      <template slot="message-content">
        <h3 class="accountTitle__title">
          {{ local.caseFile.session.remoteArgument.termsAndConditions }}:
        </h3>

        <h5 class="accountTitle__subtitle">
          بالإضافة إلى شروط استخدام بوابة ناجز؛ يلتزم المستخدم بما يلي:
        </h5>
        <br>
        <ul>
          <li class="accountTitle__subtitle">
            １- عدم تسجيل أو تصوير الجلسة عن بعد، أو جزء منها، بأي وسيلة كانت، وسواء كان التسجيل صوتياً أو مرئياً.
          </li>
          <li class="accountTitle__subtitle">
            ２- عدم انتحال المستفيد لأي شخصية أخرى، مهما كانت العلاقة أو القرابة، ولو بوجود وكالة سارية.
          </li>
        </ul>
        <br>
        <p class="accountTitle__subtitle">
          وفي حال مخالفة هذه الشروط والأحكام، فإنك ستكون معرضاً للمساءلة القانونية، وتطبيق العقوبات المنصوص عليها في الأنظمة. وبدخولك إلى هذه الخدمة، فإن ذلك يعد قبولاً لهذه الشروط والأحكام، وإقرار بعدم استخدام البوابة بشكل يخالف أي أنظمة في المملكة أو اتفاقية دولية أو بروتوكولات خاصة بالانترنت. كما أن جميع ما يقدم في البوابة من مرافعة كتابية أو وثائق أو مستندات أو حضور لجلسات عن بعد ستكون موثقة في سجلات الوزارة
        </p>
      </template>
    </naj-confirmation>

    <naj-confirmation
      :show-modal="chatResponseErrorDialog"
      :max-width="700"
      :title="`${local.common.warning}:`"
      :message="``"
      :close-btn-label="local.common.agree"
      @cancel="chatResponseErrorDialog = false"
    >
    </naj-confirmation>

    <naj-confirmation
      :show-modal="confirmSend"
      :max-width="700"
      :title="local.caseFile.session.remoteArgument.confirmSendTitle"
      :message="local.caseFile.session.remoteArgument.confirmSendMessage"
      :ok-btn-label="local.common.saveAndSend"
      :close-btn-label="local.common.close"
      @ok="addReplay"
      @cancel="confirmSend = false"
    >
    </naj-confirmation>

    <naj-confirmation
      :show-modal="showRequestReplyDialog"
      :max-width="700"
      :title="local.caseFile.session.requestPublicReply"
      :ok-btn-label="local.common.save"
      :close-btn-label="local.common.back"
      @ok="requestPublicReply"
      @cancel="showRequestReplyDialog = false"
    >
      <template slot="message-content">
        <v-form ref="requestPublicReplyReasonRef">
          <naj-input
            :type-id="formFieldType.textarea"
            :label="local.caseFile.session.remoteArgument.reason"
            :value.sync="requestPublicReplyReason"
            rows="5"
            validates="required|max:200"
          ></naj-input>
        </v-form>
      </template>
    </naj-confirmation>

    <naj-confirmation
      :show-modal="cancelDialog"
      :max-width="700"
      :title="local.common.confirmRequestCancellation"
      :message="local.common.confirmCancelRequest"
      :ok-btn-label="local.common.yes"
      :close-btn-label="local.common.close"
      @ok="confirmCancelRequest"
      @cancel="cancelDialog = false"
    >
    </naj-confirmation>

    <naj-confirmation
      :show-modal="confirmSubmitDialog"
      :max-width="700"
      :title="local.common.confirmRequestSubmission"
      :message="local.common.confirmSubmitRequest"
      :ok-btn-label="local.common.yes"
      :close-btn-label="local.common.close"
      @ok="submit"
      @cancel="confirmSubmitDialog = false"
    >
    </naj-confirmation>

    <naj-confirmation
      :show-modal="confirmSaveRequestDialog"
      :max-width="700"
      :title="local.common.confirmSaveRequest"
      :message="local.common.confirmationSaveMessage"
      :ok-btn-label="local.common.save"
      :close-btn-label="local.common.close"
      @ok="confirmSaveRequest"
      @cancel="confirmSaveRequestDialog = false"
    >
    </naj-confirmation>

    <naj-confirmation
      :show-modal="showDeleteFileDataAttachment"
      color="error"
      :title="local.common.removeConfirmation"
      :message="local.caseFile.session.remoteArgument.removeFileDataAttachmentMessage"
      :ok-btn-label="local.common.remove"
      @ok="confirmDeleteFileData"
      @cancel="cancelDeleteFileData"
    ></naj-confirmation>

    <render-attachment-modal
      :attachment-file="uploadedFile"
      :modal-visibility="showViewAttachmentModal"
      @modalClose="hideViewAttachmentModal"
    >
    </render-attachment-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('CasesModule');
const { mapState: mapGlobalState, mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');
import { userType, sessionTypes } from '@/helpers/enum';
import moment from 'moment-hijri';
import { formatDateString, apiModule } from '@/helpers/utils';
import LoadLocalAttachment from '../../../components/shared/attachment-modal/load-local-attachment';
import AttachmentCard from '@/components/shared/attachment-modal/attachment-card';
import RenderAttachmentModal from '@/components/shared/attachment-modal/render-attachment-modal';

export default {
  components: {
    LoadLocalAttachment,
    AttachmentCard,
    RenderAttachmentModal,
  },
  inject: ['$validator'],
  data() {
    return {
      apiModule,
      sessionTypes,
      caseDetails: {},
      loading: false,
      writtenPleadingMessages: [],
      publicReplyRequests: [],
      publicReplyAllowed: false,
      sessionDto: null,
      newMessage: '',
      showMessageReplied: false,
      messageReplied: {},
      fileData: {},
      allowAttachment: false,
      showRequestReplyDialog: false,
      attachFile: [],
      confirmSend: false,
      warningDialog: false,
      showGoBack: false,
      chatResponseErrorDialog: false,
      requestPublicReplyReason: '',
      cancelDialog: false,
      confirmSubmitDialog: false,
      confirmSaveRequestDialog: false,
      userCasePartyRoleInCase: {},
      formatDateString,
      lawsuitReplyNoteRequest: [],
      showDeleteFileDataAttachment: false,
      showViewAttachmentModal: false,
      isNajizOrganization: false,
      userType,
      publicReplyRequestsHeaders: [
        {
          value: 'id',
          text: this.local.caseFile.session.remoteArgument.requestNumber,
        },
        {
          value: 'creationDateFormatted',
          text: this.local.caseFile.session.remoteArgument.requestDate,
        },
        {
          value: 'requestReason',
          text: this.local.caseFile.session.remoteArgument.requestReason,
        },
        {
          value: 'statusFormatted',
          text: this.local.caseFile.session.remoteArgument.requestStatus,
        },
        {
          value: 'rejectionReason',
          text: this.local.caseFile.session.remoteArgument.notes,
        },
      ],

      lawsuitReplyNoteRequestHeaders: [
        {
          value: 'requesterName',
          text: this.local.caseFile.session.remoteArgument.requesterName,
        },
        {
          value: 'roleInCaseName',
          text: this.local.caseFile.session.remoteArgument.roleInCase,
        },
        {
          value: 'requestDate',
          text: this.local.caseFile.session.remoteArgument.replyNoteRequestDate,
        },
        {
          value: 'requestText',
          text: this.local.caseFile.session.remoteArgument.requestText,
        },
      ],
    };
  },
  computed: {
    ...mapGlobalState(['userInfo']),
    pageHead() {
      if (this.sessionTypeId == this.sessionTypes.expert) {
        let title = 'جلسة خبير';
        if (this.sessionDto && this.sessionDto.specialityName) {
          title = `${title}- ${this.sessionDto.specialityName} للقضية رقم`;
        }
        return title;
      } else if (this.sessionTypeId == this.sessionTypes.remoteArgument) {
        return `جلسة الترافع الإلكتروني للقضية رقم ${this.caseDetails.caseCode}`;
      } else if (this.sessionTypeId == this.sessionTypes.caseManagementELitigation) {
        return `جلسة تحضيرية للقضية رقم ${this.caseDetails.caseCode}`;
      }
      return '';
    },
    caseObjectKey() {
      return this.$route.query.caseObjectKey;
    },
    courtId() {
      return this.$route.query.courtId;
    },
    sessionTypeId() {
      return this.$route.query.sessionTypeId;
    },
    sessionObjectKey() {
      return this.$route.query.sessionObjectKey;
    },
    isPega() {
      return this.$route.query.isPega;
    },
    isPublicReplyAllowed() {

      /*return this.publicReplyRequests.some(request => request.statusId === 1 && !request.isCompleted);*/
      for (const request of this.publicReplyRequests) {
        if (request.statusId === 1 && !request.isCompleted) {
          if (request.allowAttachmentsInReplies) {
            this.allowAttachment = true;
          } else {
            this.allowAttachment = false;
          }
          return true;
        }
      }
      return false;
    },
    headStatusActive() {
      let endDateToValidate = this.isRemoteArgumentOrCaseManagementELitigation ? this.caseDetails.finishedDate
        : (this.sessionDto || {}).appointmentEndTime;
      return this.argumentEndDateValid(endDateToValidate);
    },
    remoteArgumentStatus() {
      if (this.headStatusActive) {
        return 'سارية';
      }
      return 'منتهية';
    },
    getAcceptedPublicReplyRequest() {
      return (this.publicReplyRequests.find(request => request.statusId === 1 && !request.isCompleted) || {}).objectKey;
    },
    disableSubmit() {
      return (
        (this.newMessage && this.newMessage.trimStart() && this.newMessage.length <= 2000) ||
        this.attachFile.length !== 0
      );
    },
    publicReplyRequestsMapped() {
      return (this.publicReplyRequests || []).map(request => ({
        ...request,
        creationDateFormatted: formatDateString(request.creationDate),
        statusFormatted: this.getRequestStatus(request.statusId),
      }));
    },
    lawsuitReplyNoteRequestMapped() {
      const replyNotes = (this.lawsuitReplyNoteRequest || []).map(note => ({
        ...note,
        requestDate: formatDateString(note.requestDate),
      }));
      const prosecutionNotesIds = [1, 2];
      const defenseNotesIds = [3, 4];
      const prosecutionNotes = replyNotes.filter(note => prosecutionNotesIds.indexOf(note.roleInCaseId) !== -1);
      const defenseNotes = replyNotes.filter(note => defenseNotesIds.indexOf(note.roleInCaseId) !== -1);
      return {
        prosecutionNotes,
        defenseNotes,
      };
    },
    uploadedFile() {
      if (this.fileData && this.fileData.sharePointId) {
        return {
          name: this.fileData.fileName,
          attachmentKey: this.fileData.attachmentKey,
          sharePointId: this.fileData.sharePointId,
          isImage: this.fileData.fileType.startsWith('image'),
          fileType: this.fileData.fileType,
        };
      }
      return {};
    },
    isRemoteArgumentOrCaseManagementELitigation() {
      return this.sessionTypeId == this.sessionTypes.remoteArgument || this.sessionTypeId == this.sessionTypes.caseManagementELitigation;
    },

  },
  mounted() {
    this.loadData();
    this.getUserInfo().then((user) => {
      this.isNajizOrganization = user && user.userType == this.userType.najizOrganization;

    });
  },
  methods: {
    ...mapActions([
      'getCaseInfo',
      'getWrittenPleadingSession',
      'getPublicReplyRequests',
      'getCaseSession',
      'pushArgumentMessage',
      'confirmUserAttendance',
      'getUserCasePartyRoleInCase',
      'uploadAttachment',
      'getLawsuitReplyNoteRequest',
      'postRequestPublicReply',
    ]),
    ...mapGlobalActions(['getUserInfo']),
    loadData() {
      const params = {
        objectKey: this.caseObjectKey,
        isPega: this.isPega,
        sessionObjectKey: this.sessionObjectKey,
        socialId: this.userInfo.socialId,
      };

      this.loading = true;
      this.getCaseInfo(params)
        .then((res) => {
          this.caseDetails = res.data;
        })
        .catch(err => this.toaster.error(err.message))
        .finally(() => (this.loading = false));

      this.getUserCasePartyRoleInCase({
        ...params,
        isPega: this.isPega == 'true',
      })
        .then((res) => {
          this.userCasePartyRoleInCase = res.data;
        })
        .catch(err => this.toaster.error(err.message))
        .finally(() => (this.loading = false));

      this.getWrittenPleadingSession(params)
        .then((res) => {
          this.writtenPleadingMessages = res.data;
        })
        .catch(err => this.toaster.error(err.message))
        .finally(() => (this.loading = false));

      this.getLawsuitReplyNoteRequest({
        ...params,
        isPega: this.isPega == 'true',
      })
        .then((res) => {
          this.lawsuitReplyNoteRequest = res.data;
        })
        .catch(err => this.toaster.error(err.message))
        .finally(() => (this.loading = false));

      if (this.isRemoteArgumentOrCaseManagementELitigation) {
        this.getPublicReplyRequests(params)
          .then((res) => {
            this.publicReplyRequests = res.data;
            this.publicReplyAllowed = this.isPublicReplyAllowed;

          })
          .catch(err => this.toaster.error(err.message))
          .finally(() => (this.loading = false));
      } else if (this.sessionTypeId == this.sessionTypes.expert) {
        //todo implement getCaseSession in icms
        this.getCaseSession(params)
          .then((res) => {
            this.sessionDto = res.data;
          })
          .catch(err => this.toaster.error(err.message))
          .finally(() => (this.loading = false));
      }
    },
    argumentEndDateValid(endDateParam) {

      if (!endDateParam) {
        return true;
      }
      const endDate = new Date(Date.parse(endDateParam)).toUTCString();
      const currentDate = new Date().toUTCString();
      return moment(endDate).isAfter(currentDate, 'second');
    },

    getSenderNameAndRole(message) {
      if (!message) {
        return;
      }
      if (message.senderRoleInCase === -1) {
        return this.isRemoteArgumentOrCaseManagementELitigation ?
          this.local.caseFile.session.remoteArgument.messageFromJudicialDepartment
          : this.local.caseFile.session.remoteArgument.messageFromExpert;
      }
      return message.senderRoleInCaseName + ':' + message.senderName;
    },

    addReplay() {
      this.newMessage = this.newMessage.trimStart();
      this.$refs.remoteArgumentReplyRef.$validator.validateAll()
        .then((valid) => {
          if (valid) {

            let typeMessage = null;
            let MessageRepliedId = '';

            if (this.showMessageReplied) {
              typeMessage = 2;
              MessageRepliedId = this.messageReplied.objectKey;
            } else if (this.publicReplyAllowed) {
              typeMessage = 3;
            } else {
              return;
            }

            this.confirmSend = false;

            const params = {
              category: typeMessage,
              parentObjectKey: MessageRepliedId || null,
              messageText: this.newMessage,
              caseObjectKey: this.caseObjectKey,
              senderRoleInCase: this.userCasePartyRoleInCase.roleInCaseId,
              sharepointId: this.fileData.sharePointId,
              attachmentTitle: this.fileData.fileName,
              replyPermissionRequestObjectKey: this.getAcceptedPublicReplyRequest,
              isPega: this.isPega,
              courtId: this.courtId,
            };

            this.pushArgumentMessage(params)
              .then((result) => {

                if (result) {
                  const res = result.data;
                  if (typeMessage === 3) {
                    this.publicReplyAllowed = false;
                    for (const request of this.publicReplyRequests) {
                      //this.publicReplyRequests[i].isCompleted = true;
                      request.isCompleted = true;
                    }
                  }
                  if (typeMessage === 2) {
                    for (const msg of this.writtenPleadingMessages) {
                      if (msg.objectKey === params.parentObjectKey) {
                        msg.casePartyCanReply = false;
                      }
                    }
                    this.publicReplyAllowed = this.isPublicReplyAllowed;
                    this.showMessageReplied = false;
                  }
                  this.writtenPleadingMessages.push(res);
                }
              }
              ).catch((ex) => {
                this.chatResponseErrorDialog = true;
                this.responseErrorMessage = 'حدث خطأ';
              });

            this.newMessage = '';

            // if (
            //   this.fileData &&
            //   this.fileData.Base64Content &&
            //   this.fileData.Base64Content !== ''
            // ) {
            //   this.$refs.attachFile.deleteFile(this.attachFile);
            // }
            // this.allowAttachment = false;
            // this.attachFile = [];
            // this.showMessageReplied = false;
          }
        });
    },

    messageType(message) {
      if (!message) {
        return '';
      }

      if (message.category === 1 || message.senderRoleInCase === -1) {
        return 'contentTile__messagesJudge';
      }

      if (message.category === 2 && message.assignedSocialIds) {
        const exists =
          message.assignedSocialIds.indexOf(
            this.userInfo.socialId
          ) !== -1;
        if (exists) {
          return 'contentTile__messagesSender';
        } else {
          return 'contentTile__messagesReceiver';
        }
      }

      const socialId = message.senderSocialId;
      if (this.userInfo.socialId === socialId) {
        return 'contentTile__messagesSender';
      } else {
        return 'contentTile__messagesReceiver';
      }
    },
    directionClass(message) {
      if (!message) {
        return '';
      }

      if (message.category === 1 && message.assignedSocialIds) {
        const exists =
          message.assignedSocialIds.indexOf(
            this.userInfo.socialId
          ) !== -1;
        if (exists) {
          return 'pleadingMessageRight';
        } else {
          return 'pleadingMessageLeft';
        }
      }

      const socialId = message.senderSocialId;
      if (this.userInfo.socialId === socialId) {
        return 'pleadingMessageRight';
      } else {
        return 'pleadingMessageLeft';
      }
    },
    hasReply(message) {
      for (const msg of this.writtenPleadingMessages) {
        if (
          msg.parentObjectKey === message.objectKey &&
          msg.senderSocialId === this.userInfo.socialId &&
          msg.senderRoleInCase === (this.userCasePartyRoleInCase.roleInCaseId)
        ) {
          return true;
        }
      }
      return false;
    },
    replyDisabledFromJudge(message) {
      return (
        !message.allowReply &&
        this.argumentEndDateValid(message.replyEndDate)
      );
    },

    checkFromPermission(parentMessage) {

      if (!parentMessage.allowReply || !parentMessage.assignedSocialIds) {
        return false;
      }

      return (
        parentMessage.category === 1 &&
        parentMessage.allowReply &&
        parentMessage.casePartyCanReply &&
        parentMessage.assignedSocialIds.includes(
          this.userInfo.socialId
        ) &&
        this.headStatusActive &&
        this.argumentEndDateValid(parentMessage.replyEndDate)
      );
    },
    onShowMessageReplied(objectKey) {

      this.publicReplyAllowed = false;
      this.messageReplied = this.writtenPleadingMessages.find((M) => {
        return M.objectKey === objectKey;
      });

      if (!this.checkFromPermission(this.messageReplied)) {
        return;
      }

      if (this.messageReplied.allowAttachmentsInReplies) {
        this.allowAttachment = true;
      } else {
        this.allowAttachment = false;
      }

      this.showMessageReplied = true;
    },
    validateParentMessages(message) {
      const parent = this.writtenPleadingMessages.find((x) => {
        return x.objectKey === message.parentObjectKey;
      });

      return parent !== null;
    },
    scrollToElement(message) {
      document
        .getElementById(message.objectKey)
        .scrollIntoView({ behavior: 'smooth' });
    },
    downLoadFile(fileId) {
      // axios
      //   .get('/file/' + btoa(fileId), { responseType: 'blob' })
      //   .then((response) => {
      //     saveAs(response.data, response.headers.filename);
      //   });
    },

    hideMessageReplied() {
      this.showMessageReplied = false;
      this.allowAttachment = false;
      this.publicReplyAllowed = this.isPublicReplyAllowed(
        this.publicReplyRequests
      );
    },
    getRequestStatus(statusId) {
      switch (statusId) {
        case 0:
          return 'جديد';
        case 1:
          return 'مقبول';
        case 2:
          return 'مرفوض';
        default:
          return '';
      }
    },
    confirmAttendance() {
      const params = {
        objectKey: this.caseObjectKey,
        isPega: this.isPega,
      };

      this.confirmUserAttendance(params)
        .then((res) => {
          if (!res) {
            this.warningDialog = false;
          } else {
            this.showGoBack = true;
          }
        });
    },
    warningDialogCancel() {
      window.history.back();
    },
    requestPublicReply() {
      this.loading = true;
      this.$refs.requestPublicReplyReasonRef.$validator.validateAll()
        .then((isValid) => {
          if (isValid) {
            this.showRequestReplyDialog = false;
            const params = {
              caseObjectKey: this.caseObjectKey,
              isPega: this.isPega,
              requestReason: this.requestPublicReplyReason,
              courtId: this.courtId,
            };
            const paramsPublicReplyRequests = {
              objectKey: this.caseObjectKey,
              isPega: this.isPega,
              sessionObjectKey: this.sessionObjectKey,
              socialId: this.userInfo.socialId,
            };

            this.postRequestPublicReply(params)
              .then((result) => {
                this.getPublicReplyRequests(paramsPublicReplyRequests)
                  .then((res) => {
                    this.publicReplyRequests = res.data;
                    this.publicReplyAllowed = this.isPublicReplyAllowed;

                  });
                this.requestPublicReplyReason = '';
                this.toaster.success(this.local.caseFile.session.remoteArgument.requestAdded);

              });
          }
        });
      this.loading = false;
    },
    confirmCancelRequest() {
      // this.$refs.replyNote.isFormHidden = true;
      // this.replyNoteCollapsed = true;
      // this.cancelDialog = false;
    },
    async submit() {
      // this.confirmSubmitDialog = false;

      // this.$refs.replyNote.Val.action = 2;
      // const response = await Services.serviceInfo[
      //   this.RequestService
      // ].submit(this.$refs.replyNote.Val);
      // const msg = response.data;
      // if (msg.statusCode === 200 || msg.statusCode === 201 || msg.statusCode === 204) {

      //   this.eventLog(
      //     `${this.RequestService}.saveAndSendRequest`,
      //     'End'
      //   );
      //   this.$refs.replyNote.Val = {
      //     caseID: '',
      //     reasons: [],
      //     relatedPartySocialId: '',
      //     replyNote: '',
      //   };
      //   this.$refs.replyNote.isFormHidden = true;
      // } else {

      //   this.messageDialog = true;
      //   if (response.data.errorMessage && response.data.errorMessage !== '') {
      //     this.message = response.data.errorMessage;
      //   } else {
      //     this.message = this.$t('validationMessages.generalError');
      //   }
      // }
      // this.$refs.replyNote.mode = 'Add';
    },
    async confirmSaveRequest() {
      // this.confirmSaveRequestDialog = false;

      // this.$refs.replyNote.Val.action = 1;
      // const response = await Services.serviceInfo[
      //   this.RequestService
      // ].submit(this.$refs.replyNote.Val);
      // const msg = response.data;
      // if (msg.statusCode === 200 || msg.statusCode === 201 || msg.statusCode === 204) {

      //   toast.success('تم حفظ الطلب بنجاح');
      //   this.$refs.replyNote.isFormHidden = true;
      //   this.$refs.replyNote.Val = {
      //     caseID: '',
      //     reasons: [],
      //     relatedPartySocialId: '',
      //     replyNote: '',
      //   };
      // } else {
      //   this.messageDialog = true;
      //   if (response.data.errorMessage && response.data.errorMessage !== '') {
      //     this.message = response.data.errorMessage;
      //   } else {
      //     this.message = this.$t('validationMessages.generalError');
      //   }
      // }
      // this.$refs.replyNote.mode = 'Add';
    },
    ConfirmSubmit() {
      this.confirmSubmitDialog = true;
    },
    fileSelected({ selectedAttachment: attachment, selectedAttachmentKey }) {
      this.loading = true;
      const reader = new FileReader();
      reader.onloadend = () => {
        var b64 = reader.result.replace(/^data:.+;base64,/, '');

        this.uploadAttachment({
          classification: 0,
          documentMetadata: {
            caseId: 0,
            caseCode: 0,
            requestId: 0,
            category: attachment.category,
            fileCategory: attachment.category,
          },
          fileCategory: attachment.category,
          extension: attachment.extension,
          base64FileContent: b64,
        })
          .then(({ data }) => {
            this.$set(this, 'fileData', {
              sharePointId: data,
              fileName: attachment.name,
              fileType: attachment.fileObject.type,
              extension: attachment.extension,
              fileCategory: attachment.category,
              attachmentKey: selectedAttachmentKey,
              base64: b64,
            });
          })
          .catch(err => this.toaster.error(err.message))
          .finally(() => (this.loading = false));
      };
      reader.readAsDataURL(attachment.fileObject);
    },
    showDeleteFileDataModal() {
      this.showDeleteFileDataAttachment = true;
    },
    confirmDeleteFileData() {
      this.$set(this, 'fileData', null);
      this.cancelDeleteFileData();
    },
    cancelDeleteFileData() {
      this.showDeleteFileDataAttachment = false;
    },
    viewAttachment() {
      this.showViewAttachmentModal = true;
    },
    hideViewAttachmentModal() {
      this.showViewAttachmentModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.header-card {
  background-color: #fff;
  box-shadow: 5px 0 12px 0 rgba(228, 230, 238, 0.6);
  border: 1px solid #e4e5e6 !important;
}

.contentTile__messagesWrapper span.textarea-counter {
  bottom: 90px;
}

.contentTile__messagesItems {
  padding: 16px;
  max-height: unset !important;
  margin: 0px;
}

.contentTile__messagesItem {
  width: 90%;
  padding: 24px 32px;
  border-radius: 16px;
  margin-bottom: 16px;
  border-top: 16px solid #e8e8e8;
  box-shadow: 0px 0px 8px #e8e8e8;
}

.contentTile__messagesHeder {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  align-items: center;
}

.contentTile__messagesDate {
  bottom: 8px;
  left: 16px;
  font-size: 10px;
}

.contentTile__messagesQuotes .contentTile__messagesBody {
  line-height: 5px;
  margin-bottom: 16px;
}

.contentTile__messagesQuotes {
  margin-top: 16px;
  width: 100%;
}

.contentTile__messagesQuotes .contentTile__messagesBody {
  line-height: 1.5;
}

.contentTile__messagesBody {
  word-break: break-word;
  font-size: 14px;
}

.contentTile__messageReplayTools {
  flex-wrap: wrap;
  // justify-content: center;
}

.contentTile__messageReplayTools {
  border-top: 1px solid #d3d3d3;
  padding-top: 16px;
  margin-top: 16px;
  display: flex;
  align-items: center;
}

.replayLastDate {
  color: #03373d;
}

.replayLastDate strong {
  font-weight: bold;
}

span.replayAttachment.notAllowed {
  color: #ae351e;
}

.replayAttachment img {
  height: 16px;
  display: block;
  margin-left: 8px;
}

.replayAttachment {
  color: #158e8c;
  display: flex;
  align-items: center;
  margin: 0px 16px;
}

button.replayToJudgeBtn {
  text-align: center;
  margin-top: 8px;
}

    .replayToJudgeBtn {
        margin-right: auto;
        padding: 16px 24px;
        background-color: var(--app-primary-color);
        border-radius: 8px;
        color: #fff !important;
    }

.replayToJudgeBtn:disabled {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666 !important;
}

.contentTile__newMessageControl {
  position: sticky;
  bottom: 0px;
  background-color: #fff;
  padding: 8px;
}

.contentTile__newMessageControl textarea.form-control.mb-3 {
  padding-bottom: 24px;
  max-height: 80px;
}

.contentTile__messagesWrapper span.textarea-counter {
  bottom: 90px;
}
</style>
